export default "__VITE_ASSET__46585fbd__"